import { render, staticRenderFns } from "./GetSignCollections.vue?vue&type=template&id=211ba9d0&"
import script from "./GetSignCollections.vue?vue&type=script&lang=js&"
export * from "./GetSignCollections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports